'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function differenceWith(firstArr, secondArr, areItemsEqual) {
    return firstArr.filter(function(firstItem) {
        return secondArr.every(function(secondItem) {
            return !areItemsEqual(firstItem, secondItem);
        });
    });
}
exports.differenceWith = differenceWith;
